export default __webpack_public_path__ + "static/media/room-play-illustration.b2c3f1b7.png";